import { LitElement, html, svg } from 'lit';

export class IconLinkExternal24 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><title>Kvadrat med pil opp mot høyre</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M22 2 11.75 12.25M22 6.5V2h-4.943M11 2H4a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-7.25"></path></svg>`; }
}
if (!customElements.get('f-icon-link-external24', IconLinkExternal24)) {
  customElements.define('f-icon-link-external24', IconLinkExternal24);
}